export const environment = {
    production: true,
    serviceName: '',
    functionName: 'https://genesistrailers-functions.azurewebsites.net',
    // functionName: '',
    baseHref: '/app/',
};
